import { useState } from "react";
import { useT } from "../lib/i18n";
import { useSelectedDate } from "../lib/selectedDate";

export function SundayMaintenanceCard({ targetKcal }: { targetKcal: number }) {
  const t = useT();
  const { selectedDate } = useSelectedDate();
  const key = `lean.dismissed_sunday_${selectedDate}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(key) === "1");
  if (dismissed) return null;
  return (
    <div className="bg-warn/10 border border-warn/30 rounded-2xl p-3 flex items-start gap-3">
      <span aria-hidden="true" className="text-xl">🛋️</span>
      <div className="flex-1 text-sm">
        <div className="font-medium">{t("today.sunday_maintenance.title")}</div>
        <div className="text-fg-muted text-sm mt-0.5">
          {t("today.sunday_maintenance.body", { kcal: targetKcal })}
        </div>
      </div>
      <button
        type="button"
        aria-label={t("common.close")}
        onClick={() => { localStorage.setItem(key, "1"); setDismissed(true); }}
        className="text-fg-faint px-1"
      >✕</button>
    </div>
  );
}
